import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seccion-planmaestro',
  templateUrl: './seccion-planmaestro.component.html',
  styleUrls: ['./seccion-planmaestro.component.css']
})
export class SeccionPlanmaestroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
